
import { HuntrixSong } from './types';

export const SODA_POP: HuntrixSong = {
    id: 'SODA_POP',
    title: "Soda Pop",
    artist: "HUNTR/X",
    midiFileName: "SodaPop.mid",
    mp3FileName: "SodaPop.mp3",
    sequencedTracks: [
        {
            "name": "Grand Piano",
            "notes": [
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "0:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "0:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "0:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "0:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "0:1:2",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "0:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "0:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "0:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "0:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "0:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "1:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "1:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "1:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "1:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "1:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "1:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "1:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "1:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "1:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A5",
                    "duration": "8n",
                    "time": "1:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "1:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "1:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "1:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "2:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "2:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "2:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "2:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "2:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "2:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "2:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "2:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "2:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "2:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "2:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "3:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "3:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "3:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "3:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "3:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "3:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "3:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "3:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "3:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "3:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "3:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "3:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "3:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "3:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "4:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "4:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "4:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "4:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "4:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "4:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B5",
                    "duration": "16n",
                    "time": "4:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "4:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "4:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "4:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "4:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "5:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "5:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "5:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "5:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "5:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B5",
                    "duration": "16n",
                    "time": "5:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "5:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "5:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "5:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "5:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "A5",
                    "duration": "16n",
                    "time": "5:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "5:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "5:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "6:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "6:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "6:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "6:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "6:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "6:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B5",
                    "duration": "16n",
                    "time": "6:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "6:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "6:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "6:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "6:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "7:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "7:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "F#5",
                    "duration": "16n",
                    "time": "7:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "7:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "7:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "7:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "7:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "7:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "A5",
                    "duration": "16n",
                    "time": "7:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "16n",
                    "time": "7:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "7:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "7:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "7:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "7:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "7:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "7:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "8:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "8:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "8:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "8:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "8:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "8:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "8:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "8:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "8:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "8:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "8:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "9:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "9:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "9:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "9:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "9:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "9:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "9:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "9:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "9:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "9:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "9:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "9:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "10:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "10:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "10:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "10:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "10:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "10:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "10:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "10:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "10:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "10:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "10:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "11:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "11:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "11:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "11:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "11:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "11:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "11:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "11:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "11:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "11:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "11:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "11:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "12:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "12:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "12:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "12:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "12:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "12:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "12:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "12:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "12:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "12:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "12:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.2
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "13:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "13:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "13:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "13:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "13:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "13:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "13:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "13:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "13:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "13:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "13:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "13:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "13:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "14:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "14:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "14:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "14:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "14:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "14:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "14:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "14:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "14:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "14:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "14:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C6",
                    "duration": "8n",
                    "time": "14:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "15:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "A5",
                    "duration": "16n",
                    "time": "15:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "15:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "15:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "A5",
                    "duration": "16n",
                    "time": "15:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "15:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "15:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "15:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "15:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "15:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "15:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "16:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "16:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "16:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "16:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "16:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "16:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "16:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "16:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "16:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "16:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "16:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "16:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "16:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "17:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "17:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "17:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "17:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "17:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "17:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "17:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "17:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "17:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "17:2:0",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "17:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "17:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "17:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "17:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "17:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "17:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "18:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "18:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "18:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "18:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "18:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "18:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "18:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "18:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "18:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "18:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "18:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "18:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "18:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "19:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "19:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "19:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "19:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "19:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "19:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "19:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "19:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "19:3:2",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "19:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "20:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "20:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "20:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "20:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "20:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "20:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "20:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "20:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "20:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "20:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "20:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "20:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "20:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "21:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "21:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "21:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "21:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "21:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "21:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "21:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "21:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "21:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "21:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "21:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "A4",
                    "duration": "16n",
                    "time": "21:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "21:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "21:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "22:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "22:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "22:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "22:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "22:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "22:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "22:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "22:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "22:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "22:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "22:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "23:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "23:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "B4",
                    "duration": "16n",
                    "time": "23:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "23:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "23:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "23:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "F3",
                    "duration": "2n",
                    "time": "24:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "2n",
                    "time": "24:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "F4",
                    "duration": "2n",
                    "time": "24:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "24:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "24:0:2",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "24:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "24:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "24:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "24:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "25:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "25:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "25:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "25:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "25:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "25:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "2n",
                    "time": "25:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "25:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "25:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "F3",
                    "duration": "2n",
                    "time": "26:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "2n",
                    "time": "26:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "F4",
                    "duration": "2n",
                    "time": "26:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "26:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "26:0:2",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "26:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "26:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "26:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "26:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "26:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "27:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "4n",
                    "time": "27:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "B5",
                    "duration": "16n",
                    "time": "27:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "A5",
                    "duration": "16n",
                    "time": "27:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "A5",
                    "duration": "16n",
                    "time": "27:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "2n",
                    "time": "27:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "2n",
                    "time": "27:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "27:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "27:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "27:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "27:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "28:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "28:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "28:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "28:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "28:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "28:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "28:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "28:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "28:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "28:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "28:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "28:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "29:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "29:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "8n",
                    "time": "29:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "29:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "29:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "29:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "29:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "29:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "29:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "29:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "D3",
                    "duration": "16n",
                    "time": "29:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "29:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "29:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "29:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "29:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "30:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "30:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "30:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "30:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "30:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "30:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "30:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "30:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "31:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "31:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "31:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "31:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "31:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "32:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "32:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "32:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "32:0:3",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "32:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "32:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "32:1:3",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "32:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "32:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "32:3:0",
                    "velocity": 0.29
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "32:3:1",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "32:3:3",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "33:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "33:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "33:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "33:0:3",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "33:1:0",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "33:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "33:1:3",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "33:1:3",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "33:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "33:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "33:3:0",
                    "velocity": 0.29
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "33:3:1",
                    "velocity": 0.29
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "33:3:3",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "34:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "34:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "34:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "34:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "34:1:3",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "34:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "34:2:3",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "34:2:3",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "34:3:0",
                    "velocity": 0.29
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "34:3:1",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "34:3:3",
                    "velocity": 0.29
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "35:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "35:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "35:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "35:0:3",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "35:1:0",
                    "velocity": 0.29
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "35:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "35:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "35:1:3",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "35:1:3",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "35:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "35:3:0",
                    "velocity": 0.29
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "35:3:3",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "36:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "36:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "36:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "36:0:3",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "36:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "36:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "36:1:3",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "36:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "36:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "36:3:0",
                    "velocity": 0.29
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "36:3:1",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "36:3:3",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "37:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "37:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "37:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "37:0:3",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "37:1:0",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "37:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "37:1:3",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "37:1:3",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "37:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "37:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "37:3:0",
                    "velocity": 0.29
                },
                {
                    "name": "A4",
                    "duration": "8n",
                    "time": "37:3:1",
                    "velocity": 0.29
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "37:3:3",
                    "velocity": 0.29
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "37:3:3",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "38:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "38:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "38:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "38:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "38:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "38:1:3",
                    "velocity": 0.29
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "38:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "38:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "38:2:3",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "38:3:0",
                    "velocity": 0.29
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "38:3:0",
                    "velocity": 0.29
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "38:3:1",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "38:3:3",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "39:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "39:0:1",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "39:0:3",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "39:0:3",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.29
                },
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "39:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "39:1:1",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "39:1:3",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "39:1:3",
                    "velocity": 0.29
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "39:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "39:2:1",
                    "velocity": 0.29
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "39:3:1",
                    "velocity": 0.29
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "39:3:1",
                    "velocity": 0.29
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "40:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "40:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "40:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "40:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "40:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "40:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B5",
                    "duration": "16n",
                    "time": "40:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "40:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "40:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "40:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A#5",
                    "duration": "8n",
                    "time": "40:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "40:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "40:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "40:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "41:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "41:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "D4",
                    "duration": "8n",
                    "time": "41:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "41:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "41:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "41:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B5",
                    "duration": "16n",
                    "time": "41:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "41:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "41:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "41:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "41:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "A5",
                    "duration": "16n",
                    "time": "41:3:1",
                    "velocity": 0.2
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "41:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "41:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "42:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "42:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "42:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "42:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "42:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "42:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "42:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "B5",
                    "duration": "16n",
                    "time": "42:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "42:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "42:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "42:2:3",
                    "velocity": 0.2
                },
                {
                    "name": "A#5",
                    "duration": "8n",
                    "time": "42:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "42:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "42:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "42:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "43:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "43:0:1",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "43:0:3",
                    "velocity": 0.2
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "43:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "B3",
                    "duration": "8n",
                    "time": "43:1:0",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "43:1:1",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "43:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "43:1:3",
                    "velocity": 0.2
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "43:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "43:2:1",
                    "velocity": 0.2
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "43:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "43:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "43:3:0",
                    "velocity": 0.2
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "43:3:3",
                    "velocity": 0.2
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "44:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "44:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "E3",
                    "duration": "16n",
                    "time": "44:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "44:1:2",
                    "velocity": 0.24
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "44:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "44:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "44:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "44:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "44:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "44:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "44:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "44:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "45:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "45:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "45:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "45:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "45:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "45:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "45:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "45:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "45:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "45:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "45:3:2",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "45:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "46:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "46:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "46:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "46:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "46:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "46:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "46:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "46:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "46:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "46:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "46:2:2",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "46:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "46:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "46:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "47:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "47:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "47:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "47:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "47:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "47:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "47:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "47:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "47:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "47:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "C6",
                    "duration": "16n",
                    "time": "47:2:0",
                    "velocity": 0.24
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "47:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "47:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "47:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "47:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "47:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "47:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "48:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "48:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "48:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "48:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "48:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "E4",
                    "duration": "16n",
                    "time": "48:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "48:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "48:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "48:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "48:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "48:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "48:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "8n",
                    "time": "48:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "48:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "49:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "49:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "49:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "49:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "49:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "49:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "49:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "49:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "49:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "4n",
                    "time": "49:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "49:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "49:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "49:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "49:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "50:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "16n",
                    "time": "50:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "50:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "4n",
                    "time": "50:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "4n",
                    "time": "50:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "50:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "50:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "16n",
                    "time": "50:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "50:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "50:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "50:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "50:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "51:0:0",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "51:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "51:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "51:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "51:0:3",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "51:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "51:1:1",
                    "velocity": 0.24
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "51:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "51:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "51:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "51:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "52:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "52:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "52:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "52:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "52:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "52:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "52:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "52:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "52:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "53:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "53:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "53:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "53:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "53:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "53:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "53:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "53:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "53:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "53:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "53:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "53:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "54:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "54:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "54:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "A4",
                    "duration": "4n",
                    "time": "54:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "54:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "54:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "54:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "54:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "54:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "55:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "55:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "55:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "55:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "55:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "55:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "55:2:1",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "55:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "55:3:0",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "55:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "55:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "55:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "56:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "56:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "56:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "56:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "4n",
                    "time": "56:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "56:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "56:2:3",
                    "velocity": 0.24
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "56:3:1",
                    "velocity": 0.24
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "56:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "56:3:3",
                    "velocity": 0.24
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "57:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "57:0:1",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "57:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "57:1:0",
                    "velocity": 0.24
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "57:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "57:1:3",
                    "velocity": 0.24
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "57:2:3",
                    "velocity": 0.25
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "57:2:3",
                    "velocity": 0.25
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "57:3:1",
                    "velocity": 0.25
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "57:3:1",
                    "velocity": 0.25
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "57:3:3",
                    "velocity": 0.26
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "57:3:3",
                    "velocity": 0.26
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "58:0:1",
                    "velocity": 0.26
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "58:0:1",
                    "velocity": 0.26
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "58:1:0",
                    "velocity": 0.26
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "58:1:0",
                    "velocity": 0.26
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "58:1:3",
                    "velocity": 0.26
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "58:1:3",
                    "velocity": 0.26
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "58:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "58:2:3",
                    "velocity": 0.27
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "58:3:1",
                    "velocity": 0.27
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "58:3:1",
                    "velocity": 0.27
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "58:3:3",
                    "velocity": 0.27
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "58:3:3",
                    "velocity": 0.27
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "59:0:1",
                    "velocity": 0.28
                },
                {
                    "name": "F3",
                    "duration": "8n",
                    "time": "59:0:1",
                    "velocity": 0.28
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "59:1:0",
                    "velocity": 0.28
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "59:1:0",
                    "velocity": 0.28
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "59:1:3",
                    "velocity": 0.28
                },
                {
                    "name": "A3",
                    "duration": "8n",
                    "time": "59:1:3",
                    "velocity": 0.28
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "59:2:3",
                    "velocity": 0.28
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "59:2:3",
                    "velocity": 0.28
                },
                {
                    "name": "D5",
                    "duration": "16n",
                    "time": "59:3:1",
                    "velocity": 0.28
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "59:3:1",
                    "velocity": 0.28
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "59:3:3",
                    "velocity": 0.28
                },
                {
                    "name": "A3",
                    "duration": "16n",
                    "time": "59:3:3",
                    "velocity": 0.28
                },
                {
                    "name": "G5",
                    "duration": "8n",
                    "time": "60:0:1",
                    "velocity": 0.28
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "60:0:1",
                    "velocity": 0.28
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "60:0:1",
                    "velocity": 0.28
                },
                {
                    "name": "E5",
                    "duration": "8n",
                    "time": "60:1:0",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "60:1:0",
                    "velocity": 0.29
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "60:1:3",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "60:1:3",
                    "velocity": 0.29
                },
                {
                    "name": "E5",
                    "duration": "4n",
                    "time": "60:2:3",
                    "velocity": 0.29
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "60:2:3",
                    "velocity": 0.29
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "60:3:1",
                    "velocity": 0.3
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "60:3:3",
                    "velocity": 0.3
                },
                {
                    "name": "E4",
                    "duration": "8n",
                    "time": "61:0:1",
                    "velocity": 0.3
                },
                {
                    "name": "C3",
                    "duration": "8n",
                    "time": "61:0:1",
                    "velocity": 0.3
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "61:0:1",
                    "velocity": 0.3
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "61:1:0",
                    "velocity": 0.3
                },
                {
                    "name": "G4",
                    "duration": "16n",
                    "time": "61:1:1",
                    "velocity": 0.3
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "61:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G3",
                    "duration": "8n",
                    "time": "61:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "61:2:0",
                    "velocity": 0.31
                },
                {
                    "name": "E5",
                    "duration": "16n",
                    "time": "61:2:1",
                    "velocity": 0.31
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "61:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "G3",
                    "duration": "16n",
                    "time": "61:2:3",
                    "velocity": 0.31
                },
                {
                    "name": "D5",
                    "duration": "8n",
                    "time": "61:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "61:3:1",
                    "velocity": 0.31
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "62:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "G#5",
                    "duration": "8n",
                    "time": "62:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "62:0:1",
                    "velocity": 0.31
                },
                {
                    "name": "F5",
                    "duration": "8n",
                    "time": "62:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "62:1:0",
                    "velocity": 0.31
                },
                {
                    "name": "G#5",
                    "duration": "8n",
                    "time": "62:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "62:1:3",
                    "velocity": 0.31
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "62:2:3",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "62:2:3",
                    "velocity": 0.32
                },
                {
                    "name": "G#5",
                    "duration": "8n",
                    "time": "62:3:1",
                    "velocity": 0.32
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "62:3:1",
                    "velocity": 0.32
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "62:3:3",
                    "velocity": 0.32
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "63:0:1",
                    "velocity": 0.33
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "63:0:3",
                    "velocity": 0.33
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "63:1:1",
                    "velocity": 0.33
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "63:1:3",
                    "velocity": 0.33
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "63:1:3",
                    "velocity": 0.33
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "63:2:1",
                    "velocity": 0.33
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "63:2:1",
                    "velocity": 0.33
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "63:2:1",
                    "velocity": 0.33
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "63:2:3",
                    "velocity": 0.34
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "63:3:1",
                    "velocity": 0.34
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "63:3:1",
                    "velocity": 0.34
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "63:3:3",
                    "velocity": 0.34
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "63:3:3",
                    "velocity": 0.34
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "64:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "64:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "64:0:3",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "64:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "64:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "64:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "64:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "64:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "64:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "64:3:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "64:3:3",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "65:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "65:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "65:0:3",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "65:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "65:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "65:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "65:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "65:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "65:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "65:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "65:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "65:3:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "65:3:3",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "66:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "66:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "66:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "66:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "8n",
                    "time": "66:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "66:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "66:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "66:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "66:2:3",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "66:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "66:3:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "66:3:3",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "67:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "67:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "67:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "67:0:3",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "8n",
                    "time": "67:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "67:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "67:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "B5",
                    "duration": "16n",
                    "time": "67:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "67:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "67:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "67:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "67:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "67:2:3",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "67:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "F#5",
                    "duration": "16n",
                    "time": "67:3:1",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "67:3:3",
                    "velocity": 0.35
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "67:3:3",
                    "velocity": 0.35
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "68:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "68:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "68:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "68:0:3",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "68:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "68:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "68:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "68:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "68:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "68:2:3",
                    "velocity": 0.35
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "68:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "68:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "68:3:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "68:3:3",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "69:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "69:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "69:0:3",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "69:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "69:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "69:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "69:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "69:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "69:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "69:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "69:2:3",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "69:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "69:3:1",
                    "velocity": 0.35
                },
                {
                    "name": "A#5",
                    "duration": "16n",
                    "time": "69:3:3",
                    "velocity": 0.35
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "69:3:3",
                    "velocity": 0.35
                },
                {
                    "name": "G#5",
                    "duration": "16n",
                    "time": "70:0:0",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "70:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "70:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "70:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "70:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "70:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "70:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "70:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "70:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "70:2:3",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "70:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "70:3:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "70:3:3",
                    "velocity": 0.35
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "71:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "71:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "71:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "71:0:3",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "71:0:3",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "71:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "71:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "71:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "71:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "71:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "71:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "71:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "71:3:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "71:3:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "72:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "72:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "72:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "72:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "D#5",
                    "duration": "16n",
                    "time": "72:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "72:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "8n",
                    "time": "72:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "F#3",
                    "duration": "8n",
                    "time": "72:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "72:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "72:3:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "72:3:3",
                    "velocity": 0.35
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "72:3:3",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "8n",
                    "time": "73:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "73:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "73:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "73:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "73:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "73:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "73:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "73:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "73:2:3",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "73:2:3",
                    "velocity": 0.35
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "73:3:0",
                    "velocity": 0.35
                },
                {
                    "name": "D#5",
                    "duration": "8n",
                    "time": "73:3:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "73:3:3",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "74:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "74:0:1",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "74:0:2",
                    "velocity": 0.35
                },
                {
                    "name": "F5",
                    "duration": "16n",
                    "time": "74:0:3",
                    "velocity": 0.35
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "74:1:0",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "74:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "74:1:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "74:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "C#3",
                    "duration": "16n",
                    "time": "74:1:3",
                    "velocity": 0.35
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "74:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "74:2:1",
                    "velocity": 0.35
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "74:2:1",
                    "velocity": 0.35
                }
            ]
        },
        {
            "name": "Electric Piano",
            "notes": [
                {
                    "name": "C1",
                    "duration": "16n",
                    "time": "0:0:0",
                    "velocity": 0.39
                }
            ]
        }
    ],
    structure: [
        { type: 'VERSE', duration: 16, rhythm: 'HOUSE', lyrics: ["Don't want you, need you", "Yeah, I need you to fill me up", "Masigo masyeo bwado", "Seonge cha ji ana (It's not enough)"] },
        { type: 'VERSE', duration: 16, rhythm: 'HOUSE', lyrics: ["Got a feeling that, oh, yeah", "You could be everything that I need, taste so sweet", "Every sip makes me want more, yeah"] },
        { type: 'PRE_CHORUS', duration: 16, rhythm: 'BUILDUP', lyrics: ["Lookin' like snacks 'cause you got it like that", "Take a big bite, want another bite, yeah", "I want all of you, want it, want it", "When you're in my arms, I hold you so tight"] },
        { type: 'CHORUS', duration: 16, rhythm: 'HOUSE', lyrics: ["You're all I can think of, every drop I drink up", "You're my soda pop, my little soda pop", "Cool me down, you're so hot", "Pour me up, I won't stop, you're my soda pop"] },
        { type: 'VERSE', duration: 16, rhythm: 'HOUSE', lyrics: ["Uh, make me wanna flip the top", "You hit the spot", "Every little drip and drop, fizz and pop, ah", "It's gettin' hot"] }
    ],
    musicalData: {
        keyRoot: "C",
        scale: "major",
        bpm: 126,
        defaultTheme: {
            chordProgression: [0, 3, 4, 0],
            bassPattern: [1, 0, 1, 0, 1, 0, 1, 0],
            melodyPattern: [0, 4, 7, 4, 0, 4, 7, null]
        },
        themes: {
            VERSE: {
                chordProgression: [0, 4],
                bassPattern: [1, 0, 0, 0, 1, 0, 0, 0],
                melodyPattern: [4, 4, 4, 7, 4, null, null, null]
            },
            CHORUS: {
                chordProgression: [3, 0, 4, 0],
                bassPattern: [1, 0, 1, 0, 1, 1, 1, 1],
                melodyPattern: [7, 7, 9, 7, 4, 4, 0, 0]
            }
        }
    }
};
